<template>
	<div>
		<el-button :loading="enableLoading" size="small" @click="changeAttrInBtnGroup(1)" type="success" plain>审核通过</el-button>
		<el-button :loading="disableLoading" size="small" @click="changeAttrInBtnGroup(0)" type="warning" plain>继续审核</el-button>
		<el-button :loading="deleteLoading" size="small" @click="changeAttrInBtnGroup(-1)" type="danger" plain>退出企业</el-button>
	</div>
</template>

<script>
  import http from '../../assets/js/http'

  export default {
    props: ['selectedData', 'type', 'name', 'id'],
    data() {
      return {
        enableLoading: false,
        disableLoading: false,
        deleteLoading: false
      }
    },
    methods: {
      getUrl() {
        return 'admin/' + this.type
      },
      getSelectedIds() {
        let array = []
        _(this.selectedData).forEach((res) => {
          array.push(res.id)
        })
        return array
      },
      changeAttrInBtnGroup(cate) {
        if (!this.selectedData.length) {
          _g.toastMsg('warning', '请勾选数据')
          return
        }
        let word = ''
        if (cate == 1) {
          word = '恢复正常'
          this.enableLoading = !this.enableLoading
        } else if (cate == 0) {
          this.disableLoading = !this.disableLoading
          word = '开启审核'
        } else {
          this.deleteLoading = !this.deleteLoading
          word = '退出企业'
        }
        let url = this.getUrl() + '/company_enables'
        let data = {
          ids: this.getSelectedIds(),
          status: cate
        }
        this.apiPost(url, data).then((res) => {
          this.handelResponse(res, (data) => {
            _g.toastMsg('success', '操作成功')
            setTimeout(() => {
              if (cate == 1) {
                this.enableLoading = !this.enableLoading
              } else {
                this.disableLoading = !this.disableLoading
              }
              this.showgoback()
            }, 1500)
          }, () => {
            if (cate == 1) {
              this.enableLoading = !this.enableLoading
            } else {
              this.disableLoading = !this.disableLoading
            }
          })
        })
      },
      deleteDatasInBtnGroup() {
        if (!this.selectedData.length) {
          _g.toastMsg('warning', '请勾选数据')
          return
        }
        this.deleteLoading = !this.deleteLoading
        let url = this.getUrl() + '/company_deletes'
        let data = {
          ids: this.getSelectedIds()
        }
        this.apiPost(url, data).then((res) => {
          this.handelResponse(res, (data) => {
            _g.toastMsg('success', res.data)
            setTimeout(() => {
              this.showgoback()
            }, 1500)
          }, () => {
            this.deleteLoading = !this.deleteLoading
          })
        })
      },
      showgoback(){
        this.$emit('closeMain',0)
      }
    },
    computed: {
      enableShow() {
        return _g.getHasRule(this.type + '-enables')
      },
      deletesShow() {
        return _g.getHasRule(this.type + '-deletes')
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// btn-user-company.vue?53508dc8